import {SmileyIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {useImperativeHandle} from 'react'

import {VALUES} from '../constants/values'
import styles from './ReactionViewerAnchor.module.css'

type RenderAnchorProps = React.HTMLAttributes<HTMLElement> & {ref?: React.Ref<HTMLElement>}
type ReactionViewerAnchorProps = {
  renderAnchorProps?: RenderAnchorProps
  reactionsAvailable?: boolean
  ref?: React.Ref<HTMLButtonElement>
}

export const ReactionViewerAnchor = ({ref, renderAnchorProps, reactionsAvailable}: ReactionViewerAnchorProps) => {
  const {ref: anchorRef, ...restAnchorProps} = renderAnchorProps ?? {}

  // Pass AnchoredOverlay's *object* anchor ref straight to IconButton. Merging it with
  // the forwarded ref produced a *callback* ref, which silently breaks IconButton's
  // built-in Tooltip: Primer's TooltipV2 reads `triggerRef.current` (via the
  // callback-incompatible useProvidedRefOrCreate) to open/position the popover, so a
  // function ref means it never opens on hover/focus.
  const anchorObjectRef = anchorRef as React.RefObject<HTMLButtonElement> | undefined
  useImperativeHandle<HTMLButtonElement | null, HTMLButtonElement | null>(ref, () => anchorObjectRef?.current ?? null, [
    anchorObjectRef,
  ])

  return (
    <IconButton
      size="small"
      icon={SmileyIcon}
      {...restAnchorProps}
      aria-label={reactionsAvailable ? VALUES.react : VALUES.reactionsUnavailable}
      tooltipDirection="n"
      inactive={!reactionsAvailable}
      aria-labelledby={undefined}
      className={styles.ReactionViewerAnchorButton}
      ref={anchorObjectRef}
    />
  )
}

ReactionViewerAnchor.displayName = 'ReactionViewerAnchor'
